import { USAGE_UNLIMITED } from '../constants/common';

export function hasSubscriptionLimit(limit: number | null) {
  return !!limit && (limit > 0 || limit === USAGE_UNLIMITED);
}
